/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiCheckbox, EuiLink, htmlIdGenerator } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

interface AgreeToInternalPolicyCheckboxProps {
  checked: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
}

const internalPolicyLink = 'https://elasticco.atlassian.net/wiki/x/R5zfAg'

export const AgreeToInternalPolicyCheckbox = (props: AgreeToInternalPolicyCheckboxProps) => {
  const { checked, onChange } = props
  const makeId = htmlIdGenerator()

  return (
    <EuiCheckbox
      data-test-id='agree-to-internal-policy-checkbox'
      id={makeId()}
      label={
        <FormattedMessage
          id='agree-to-internal-policy'
          defaultMessage='I confirm that I have followed the { policyLink }.'
          values={{
            policyLink: (
              <EuiLink
                data-test-id='agree-to-internal-policy-checkbox.link'
                href={internalPolicyLink}
                external={true}
                target='_blank'
              >
                <FormattedMessage
                  id='agree-to-internal-policy.link'
                  defaultMessage='temporary resource policy'
                />
              </EuiLink>
            ),
          }}
        />
      }
      checked={checked}
      onChange={onChange}
    />
  )
}
